<!--
 * @author yuping.pang
 * @date 2022-10-11 14:59
 * @description 异步导入，  导入文件之后在任务中心查看进度和结果
-->
<template>
  <div class="import-async-container">
    <ls-text-upload
      :needDelect="false"
      :needClip="false"
      :needDown="false"
      :fileList="[]"
      :uploadConfig="myUploadConfig"
      :customUploadFun="uploadToAliyun"
      :successFun="uploadSuccessCallback"
      :style="uploadStyle"
      v-show="false"
    >
      <template slot="customRender">
        <slot name="btn">
          <a-button :type="btnType" :loading="btnLoading">{{ btnText }}</a-button>
        </slot>
      </template>
    </ls-text-upload>
    <lsDownLoad
      ref="downLoad"
      :goToUrl="downloadPageUrl"
      downloadBtn="打开任务中心"
      :successContent="successContent"
      :errorContent="errorContent"
      :apiFun="modalCallback || myCodalCallback"
    />
  </div>
</template>

<script>
import { getToken, apiUcTaskEstablish } from '@/services/module/base';
import OSS from 'ali-oss';

export default {
  name: 'ImportAsync',
  components: {
  },
  props: {
    btnType: { // 按钮类型
      type: String,
      default: 'primary'
    },
    btnText: { // 按钮文案
      type: String,
      default: '导入'
    },
    uploadConfig: {
      type: Object,
      default: () => ({})
    },
    sendData: { // 导入传参
      type: Object,
      default: () => ({})
    },
    uploadStyle: {
      type: Object,
      default: () => ({})
    },
    // eslint-disable-next-line vue/require-default-prop
    beforeTaskEstablish: Function, // 推送任务之前
    // eslint-disable-next-line vue/require-default-prop
    customSuccessCallback: Function, // 成功进行异步导入之后回调
    // eslint-disable-next-line vue/require-default-prop
    modalCallback: Function, // 导入之后弹窗的回调
    // eslint-disable-next-line vue/require-default-prop
    customFailCallback: Function // 导入之后失败回调
  },
  data () {
    return {
      btnLoading: false,
      downloadPageUrl: process.env.VUE_APP_API_SCM_URL + '/#/download-page/download-page?type=import',
      successContent: {
        content: '文件导入需要一些时间，请耐心等候，同时您可以前往任务中心查看执行进度。',
        tip: '加入导入列表成功！'
      },
      errorContent: {
        tip: '加入导入列表失败！'
      }
    }
  },
  computed: {
    // 对于配置属性进行监听
    myUploadConfig () {
        return Object.assign({
          accept: '.xls,.xlsx', // 格式限制
          limitNumber: 5, // 文件数量
          limitSize: 100, // 文件大小限制
          nameLength: 100,
          specialSymbolCheckIs: true // 是否校验特殊符号
        }, this.uploadConfig, this.$attrs)
    }
  },
  methods: {
    // 上传阿里云成功之后回调
    uploadSuccessCallback (res) {
      const imageUrl = decodeURI(res.res.requestUrls[0]);
      const uid = res.res.headers['x-oss-request-id'];
      const fileName = res.name.substr(res.name.indexOf('_') + 1);
      const fileObj = {
        uid,
        fileName,
        imageUrl
      }
      if (this.beforeTaskEstablish) {
        this.beforeTaskEstablish(fileObj);
      }
      this.btnLoading = true;
      apiUcTaskEstablish({
        "belongUserNo": sessionStorage.getItem('jobNo'), // 当前操作人工号
        "belongUserName": sessionStorage.getItem('realName'), // 当前操作人
        "sourceFileUrl": imageUrl, // 上传的excel的URL,
        ...this.sendData
      }).then(res => {
        this.btnLoading = false;
        if (this.customSuccessCallback) { // 自定义回调
          const preventDefault = this.customSuccessCallback(fileObj, res);
          if (preventDefault) {
            return;
          }
        }
        const resData = res.data || {};
        this.$refs.downLoad.openModal(resData);
      }).catch(err => {
        const resData = {
          message: err?.message || JSON.stringify(err),
          successIs: false
        }
        if (this.customFailCallback) {
          const preventDefault = this.customFailCallback(err);
          if (preventDefault) {
            return;
          }
        }
        this.btnLoading = false;
        this.$refs.downLoad.openModal(resData);
      })
    },
    myCodalCallback (resData) {
      return new Promise((resolve, reject) => {
        if (resData && resData.successIs) {
          resolve({ state: 100 })
        } else {
          const msg = resData?.message || '文件导入过程中出现了问题。';
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({ state: 400, msg });
        }
      })
    },
    uploadToAliyun (action) {
      return new Promise((resolve, reject) => {
        getToken().then(res => {
          if (res.data) {
            const result = res.data;
            const client = new OSS({
              accessKeyId: result.items.accessKeyId,
              accessKeySecret: result.items.accessKeySecret,
              stsToken: result.items.securityToken,
              region: 'oss-cn-shenzhen',
              bucket: 'scm-uc' // 任务中心导入专用
            })
            const filename = action.file.name;
            const pathPreFix = process.env.VUE_APP_ASYNC_IMPORT_FOLDER; // 任务中心异步导入固定文件夹
            const filePath = this.$moment().format('YYYYMMDD');
            const url = pathPreFix + filePath + '/' + new Date().getTime() + '_' + filename
            client.put(url, action.file).then(res => {
              resolve(res)
            }).catch(err => {
              reject(err)
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .import-async-container{
    display: inline;
  }

</style>
